import MenuItem from '@zenbusiness/zui/MenuItem';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import CopyButton from '#client/components/CopyButton';
import useBreakpoints from '#client/hooks/useBreakpoints';

export default function MenuItemRow({ copyText, title, texts, callback = () => {} }) {
  const theme = useTheme();
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  const placement = isDesktop && texts.some((text) => text.length >= 16) ? 'top' : 'right';

  return (
    <MenuItem
      sx={{
        '&:hover': {
          backgroundColor: theme.palette.background.cyan.light
        }
      }}
    >
      <Stack gap="8px">
        <Text
          color="tertiary"
          size="xs"
        >
          {title}
        </Text>
        <Stack
          alignItems="center"
          direction="row"
          gap="8px"
        >
          <Stack gap="2px">
            {texts.map((text, index) => (
              <Text
                color="primary"
                component="p"
                // eslint-disable-next-line react/no-array-index-key
                key={`${title}-${index}`}
                size="md"
                sx={{
                  width: text ? 'auto' : '200px'
                }}
              >
                {text || <Skeleton width="100%" />}
              </Text>
            ))}
          </Stack>
          {copyText && (
            <CopyButton
              callback={callback}
              copyText={copyText}
              placement={placement}
            />
          )}
        </Stack>
      </Stack>
    </MenuItem>
  );
}

MenuItemRow.propTypes = {
  copyText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  texts: PropTypes.arrayOf(PropTypes.string).isRequired,
  callback: PropTypes.func
};
